/**
 * Alpine.js Capability Picker Component
 *
 * Backs the grouped, searchable capability selectors on the per-user
 * Capabilities page (mod/moderator_grants.twig). Rows are server-rendered
 * inside collapsible category sections. This component only handles
 * presentation state: the search filter, per-category expand/collapse, and the
 * current selection. The selected wire value flows into a hidden
 * `name="permission"` input, so the submitted value stays the raw capability
 * string and the server-side grant/deny guards are unchanged.
 *
 * Each row reports its own search haystack (lowercased label + wire id +
 * description) and its category's combined haystack, so matching and
 * auto-expand are computed without the component needing the data up front.
 */
export function capabilityPicker() {
    return {
        // Search query.
        q: '',
        // Selected wire value (e.g. 'report.view'), bound to the hidden input.
        selected: '',
        // Friendly label of the selection, for the summary line.
        selectedLabel: '',
        // Per-category manual expand state, keyed by category label.
        open: {},

        needle() {
            return this.q.trim().toLowerCase();
        },

        rowVisible(haystack) {
            const n = this.needle();
            return n === '' || haystack.includes(n);
        },

        categoryVisible(categoryHaystack) {
            const n = this.needle();
            return n === '' || categoryHaystack.includes(n);
        },

        // While searching, auto-expand any category that has a match and hide
        // the rest. Otherwise use the manual toggle state (collapsed default).
        isOpen(category, categoryHaystack) {
            if (this.needle() !== '') {
                return this.categoryVisible(categoryHaystack);
            }

            return this.open[category] === true;
        },

        toggle(category) {
            this.open[category] = !this.open[category];
        },

        select(value, label) {
            this.selected = value;
            this.selectedLabel = label;
        },

        clear() {
            this.selected = '';
            this.selectedLabel = '';
        },
    };
}
